// extracted by mini-css-extract-plugin
export default {"otpGroup":"OtpInput_otpGroup__dm+XL","otpInput":"OtpInput_otpInput__X5pGR"};